// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__12pYz","description":"PatientConsentPreview_description__2hTw_"};